<template>
    <v-menu>
        <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on" :small="small" :icon="icon">
                <slot></slot>
            </v-btn>
        </template>
        <v-list>
            <v-list-item v-for="type in networks" :key="type.network" dense>
                <v-btn small text @click="$emit('copy')" v-if="type.network === 'copy'">
                    <v-icon class="mr-2" small>content_copy</v-icon>{{ type.name }}
                </v-btn>
                <v-btn small text :href="url" target="_blank" rel="noopener" v-else-if="type.network === 'tab'">
                    <v-icon class="mr-2" small>tab</v-icon>{{ type.name }}
                </v-btn>
                <ShareNetwork v-else
                              :network="type.network"
                              :url="url"
                              :title="sharing.title"
                              :description="sharing.description"
                              :quote="sharing.quote"
                              :hashtags="sharing.hashtags"
                              :twitterUser="sharing.twitterUser">
                    <v-icon small class="mr-2">{{ type.icon }}</v-icon>
                    <span>{{ type.name }}</span>
                </ShareNetwork>
            </v-list-item>
        </v-list>

    </v-menu>
</template>
<style scoped>
.v-list-item > a {
    text-decoration: none !important;
}
</style>
<script>
import Vue from "vue";
import VueSocialSharing from "vue-social-sharing";
import { mdiTwitter } from "@mdi/js";

Vue.use(VueSocialSharing);

export default {
    name: "BnftShareMenu",
    props: {
        url: String,
        copy: String,
        small: Boolean,
        icon: Boolean,
    },
    data: () => {
        return {
            sharing: {
                title: "Create or commission a braNFT today!",
                description: `A BraNFT™ is a truly unique crypto asset tied to real world physical assets... literally.`,
                quote: `A BraNFT™ is a truly unique crypto asset tied to real world physical assets... literally.`,
                hashtags: "BraNFT, bra, nft",
                twitterUser: "branfts",
            },
            networks: [
                {
                    network: "tab",
                    name: "Open Tab",
                    icon: "tab",
                },
                {
                    network: "copy",
                    name: "Copy Link",
                    icon: "content_copy",
                },
                {
                    network: "email",
                    name: "Email",
                    icon: "email",
                    color: "#333333",
                },
                {
                    network: "facebook",
                    name: "Facebook",
                    icon: "facebook",
                    color: "#1877f2",
                },
                {
                    network: "sms",
                    name: "SMS",
                    icon: "sms",
                    color: "#333333",
                },
                {
                    network: "twitter",
                    name: "Twitter",
                    icon: mdiTwitter,
                    color: "#1da1f2",
                },
                {
                    network: "whatsapp",
                    name: "Whatsapp",
                    icon: "whatsapp",
                    color: "#25d366",
                },
            ],
        };
    },
};
</script>